import React from 'react';
import AdminDashboardContent from './AdminDashboardContent';
import '../../../style/scss/dashboard.scss';

const AdminDashboard: React.FC = () => {
    return (
        <div className='container-wide'>
            <AdminDashboardContent />
        </div>
    );
};

export default AdminDashboard;
